<div class="w-full">
  <div>
    <div class="px-4">
      <div
        *ngTemplateOutlet="recursiveMenu; context: { $implicit: dataSource$ | async, root: true }"
      ></div>
      <ng-template #recursiveMenu let-menus let-root="root">
        <ul class="text-base text-aux-gray-dark-3" [class.py-3]="!root" [class.pb-3]="root">
          @for (menu of menus; track menu) {
            <li
              [ngClass]="{
                'flex cursor-pointer flex-col': hasChild(menu) || singleRoute(menu),
                'sub-level relative ml-4 flex items-center border-l-[2px] border-aux-gray-light-5':
                  isCollapsable(menu),
              }"
            >
              <!-- level 1 -->
              @if (hasChild(menu)) {
                <div
                  (click)="onItemSelected(menu)"
                  [class.cursor-default]="menu.url === selectedParentRoute"
                  [ngClass]="{
                    'bg-aux-gray-light font-medium text-aux-blue-dark-1':
                      isActiveLink(menu.url) || expanded[menu.url],
                    'items-center': !menu?.primaryBadgeInfo,
                    'items-start': menu?.primaryBadgeInfo,
                    'hover:text-aux-blue-dark': !isActiveLink(menu.url),
                  }"
                  class="group/first-level flex justify-between gap-2 text-nowrap rounded-[8px] px-4 py-3"
                >
                  <ng-container *ngVar="isActiveLink(menu.url)">
                    <div
                      [ngClass]="{
                        'items-center': !menu?.primaryBadgeInfo,
                        'items-start': menu?.primaryBadgeInfo,
                      }"
                      class="flex"
                    >
                      @if (menu.svg) {
                        <aux-icon [name]="menu.svg" style="stroke-width: 1px" class="mr-2" />
                      }

                      <div>
                        <div
                          class="nav-header-primary"
                          [ngClass]="{
                            'group-hover/first-level:underline': !isActiveLink(menu.url),
                          }"
                        >
                          {{ menu.name }}
                        </div>

                        @if (menu?.primaryBadgeInfo) {
                          <div>
                            {{ menu?.primaryBadgeInfo }}
                          </div>
                        }
                      </div>
                    </div>

                    <button
                      class="flex h-fit transform items-center justify-center rounded-full transition duration-300 ease-in-out focus:outline-none"
                      [attr.aria-label]="'Toggle ' + menu.name"
                      [ngClass]="{
                        hidden: menu.url === selectedParentRoute,
                        '-rotate-180': expanded[menu.url],
                      }"
                    >
                      <aux-icon name="ChevronDown" style="width: 16px; height: 16px" />
                    </button>
                  </ng-container>
                </div>
              }

              <!-- sub level or single menu item -->
              @if (isCollapsable(menu) || singleRoute(menu)) {
                <div
                  class="group/sub-level relative flex w-full items-center rounded-[8px] py-3 pr-4 font-medium"
                  [routerLink]="menu.url"
                  [ngClass]="{
                    'bg-aux-blue-light-50 text-aux-blue-dark-1':
                      isActiveLink(menu.url) && isCollapsable(menu),
                    'bg-aux-gray-light font-medium text-aux-blue-dark-1':
                      isActiveLink(menu.url) && singleRoute(menu),
                    'ml-[13px] text-sm': isCollapsable(menu),
                    'pl-4': singleRoute(menu),
                    'hover:text-aux-blue-dark hover:underline': !isActiveLink(menu.url),
                  }"
                  (mouseenter)="openFlyOutMenu()"
                  (mouseleave)="isFlyOutMenuOpened = false"
                >
                  @if (isCollapsable(menu)) {
                    <div
                      class="absolute -left-[15px] h-2 w-4 rounded-bl-full border-b-[2px] border-l-[2px] border-aux-gray-light-5"
                    ></div>
                  }

                  <div
                    *ngVar="isActiveLink(menu.url) as isActive"
                    class="flex w-full items-center justify-between"
                  >
                    <div class="flex items-center">
                      @if (
                        {
                          svg: (isActive && menu.activeSvg) || menu.svg,
                        };
                        as obj
                      ) {
                        <div
                          class="flex items-center justify-center"
                          [ngClass]="{
                            'mr-2': obj.svg,
                          }"
                        >
                          @if (obj.svg) {
                            <aux-icon
                              [name]="obj.svg"
                              [ngClass]="menu.className"
                              style="stroke-width: 1px"
                            />
                          }
                        </div>
                      }
                      <a
                        [ngClass]="{ 'pl-3': isCollapsable(menu) && !menu.svg }"
                        class="grow-0 overflow-hidden text-ellipsis whitespace-nowrap group-hover/first-level:underline"
                      >
                        {{ menu.name }}
                      </a>
                      @if (menu?.rightSvg) {
                        <aux-icon
                          [name]="menu?.rightSvg"
                          [size]="17.25"
                          style="stroke-width: 1px"
                          class="ml-2"
                        />
                      }
                      @if (menu?.badge?.amount | async; as badgeAmount) {
                        <span
                          class="ml-2 flex h-6 w-6 items-center justify-center rounded-full bg-aux-error"
                          [auxTooltip]="menu?.badge?.tooltip || ''"
                        >
                          <span class="text-sm font-bold text-aux-gray-light">
                            {{ badgeAmount }}
                          </span>
                        </span>
                      }
                    </div>

                    @if (menu?.flyOutMenu) {
                      <button
                        class="ml-4 flex h-fit items-center justify-center rounded-full focus:outline-none"
                      >
                        <aux-icon name="ChevronRight" style="width: 16px; height: 16px" />
                      </button>

                      @if (isFlyOutMenuOpened) {
                        <div
                          #flyOutMenu
                          class="absolute left-full z-[1000] hidden w-[175px] transform rounded-[8px] bg-white text-aux-gray-dark-3 opacity-0 transition-opacity duration-500 ease-in-out group-hover/sub-level:block group-hover/sub-level:opacity-100"
                          [ngClass]="flyOutMenuClass"
                          style="box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3)"
                        >
                          @for (subMenu of menu?.flyOutMenu; track subMenu) {
                            <div
                              class="px-4 py-2 hover:text-aux-blue-dark hover:underline"
                              (click)="onFlyOutMenuItemSelected($event, subMenu.url)"
                            >
                              {{ subMenu.name }}
                            </div>
                          }
                        </div>
                      }
                    }
                  </div>
                </div>
              }

              <!-- Divider -->
              @if (isDivider(menu)) {
                <hr class="my-4 border-t-[2px] border-aux-gray-light-3" />
              }

              <!-- sub level -->
              @if (hasChild(menu) && menu.subRoutes && expanded[menu.url]) {
                <ul id="nav{{ menu.name }}">
                  <ng-container
                    *ngTemplateOutlet="recursiveMenu; context: { $implicit: menu.subRoutes }"
                  />
                </ul>
              }
            </li>
          }
        </ul>
      </ng-template>
    </div>
  </div>
</div>
